import {ValueObject} from '@s-ui/domain'

export class CreateReservationTransactionsRequestValueObject extends ValueObject {
  #adId
  #buyerId

  constructor({adId, buyerId}) {
    super()
    this.#adId = adId
    this.#buyerId = buyerId
  }

  static create({adId, buyerId}) {
    return new CreateReservationTransactionsRequestValueObject({adId, buyerId})
  }

  get adId() {
    return this.#adId
  }

  get buyerId() {
    return this.#buyerId
  }

  get value() {
    return {
      adId: this.#adId,
      buyerId: this.#buyerId
    }
  }

  toJSON() {
    return {
      adId: this.#adId,
      buyerId: this.#buyerId
    }
  }
}
